import React from 'react';
import Structure from './components/structure';
import Routes from './routes';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { HomologatorProvider } from './components/homologator-context';

const component = connect(({ oidc }) => ({ authenticated: !!oidc.user && !oidc.user.expired }));

// Also provides unconnected component for testing
export function Main({ authenticated }) {
  return authenticated
    ? <HomologatorProvider><Structure><Routes /></Structure></HomologatorProvider>
    : <Routes />;
}

export default withRouter(component(Main));
